
























































import { Component, Vue } from 'vue-property-decorator';
import SmallDashDisplay from '@/components/SmallDashDisplay.vue';
import SolarVsGrid from '@/components/SolarVsGrid.vue';
import MyNeighbourhood from '@/components/MyNeighbourhood.vue';
import BusTimes from '@/components/BusTimes.vue';
import Electricity from '@/components/Electricity.vue';
import YearlyElectricity from '@/components/YearlyElectricity.vue';

@Component({
    components: {
        SolarVsGrid,
        MyNeighbourhood,
        BusTimes,
        Electricity,
        YearlyElectricity,
        SmallDashDisplay,
    },
})
export default class DashBoard extends Vue {

    private fullpageOptions: object = {
        licenseKey: '4BA524F4-2B5F472C-8113CCC4-65E9F707',
        loopTop: false,
        loopBottom: false,
        sectionsColor: ['#446688', '#446688', '#446688', '#446688', '#446688'],
        normalScrollElements: '.card, .card-content, .card-canvas',
        paddingTop: '0px',
        fitToSection: true,
    };

    private windowWidth: number = 0;
    private windowHeight: number = 0;

    public created() {

        return;
    }

    public mounted() {

        const self  = this;

        return;
    }

    // private getWindowWidth() {
    //     this.windowWidth = document.documentElement.clientWidth;
    // }

    // private getWindowHeight() {
    //     this.windowHeight = document.documentElement.clientHeight;
    // }

    private onActionPressed() {
        alert('Hi');
    }
}
